import React from 'react';
import { List, Typography } from '@mui/material';
import { AbstractRequest } from '../../../api/RequestApi';

interface RequestListWidgetProps<T extends AbstractRequest> {
    loading: boolean;
    requests: T[];
    renderItem: (request: T) => React.ReactNode;
    emptyMessage?: string;
}

export function RequestListWidget<T extends AbstractRequest>({ loading, requests, renderItem,
                                                         emptyMessage = 'Keine Daten verfügbar' }: RequestListWidgetProps<T>) {

    if (loading) {
        return null;
    }

    if (!requests || requests.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                {emptyMessage}
            </Typography>
        );
    }

    return (
        <List className="pending-requests-widget">
            {requests.map((request) => (
                <React.Fragment key={request.id}>
                    {renderItem(request)}
                </React.Fragment>
            ))}
        </List>
    );
}